import object1 from "./1.png";

export const makeUpRemover1 = [object1, object1, object1, object1, object1];
